import gql from 'graphql-tag';

const USER_SEND_ACTIVATION_EMAIL = gql`
mutation userActivationResend ($id: ID!) {
    userActivationResend (id: $id)
}
`;

export default USER_SEND_ACTIVATION_EMAIL;